import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Space, Button, Modal, Tag, Input, Form, Alert } from "antd";
import {
  ReadOutlined,
  RightCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  RightOutlined,
  FormOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import { maskMoney } from "../../../helpers/masks";
import dayjs from "dayjs";
import { ItemList } from "../../../components/itemList";
import { converterDecimalParaHorasMinutos } from "../../../helpers/formatDate";
const { Text } = Typography;
const array_tipo = ["Curso Online (Autoestudo)", "Curso Interativo (Online ou Presencial)"];

export const LancamentoTreinamentosDetalhes = () => {
  const [form] = Form.useForm();
  const { id_grupo, id_curso } = useParams();
  const navigate = useNavigate();
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // DADOS
  const [grupo, setGrupo] = useState({});

  useEffect(() => {
    if (id_grupo > 0) {
      carregarGrupo(id_grupo);
      carregarCurso(id_curso);
    }
  }, [id_grupo]);

  // CARREGAR GRUPO
  const carregarGrupo = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_grupos/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setGrupo(api?.response?.data);
    } else {
      navigate("/treinamentos/lancamento/grupos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const carregarCurso = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_cursos/carregar_detalhes/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      navigate("/treinamentos/lancamento/grupos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // INICIAR
  const iniciarCurso = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/treinamentos_cursos/iniciar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Incrição realizada com sucesso!");
      carregarCurso(id_curso);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CONCLUIR
  const concluirCurso = async (formData) => {
    setLoading(true);
    const api = await http("post", `v1/treinamentos_cursos/concluir`, formData);
    if (api.statusCode === 200) {
      message.success("Treinamento/Curso concluído com sucesso!");
      carregarCurso(id_curso);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RENDER ITEM
  const RenderItem = ({ titulo, descricao }) => {
    return (
      <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: 20 }}>
        <Space direction="vertical" size={0}>
          <Text type="secondary" style={{ fontSize: 14 }}>
            {titulo}
          </Text>
          <Text strong style={{ fontSize: 16 }}>
            {descricao ?? "-"}
          </Text>
        </Space>
      </Col>
    );
  };

  const renderStatus = (status) => {
    if (status === 1) {
      return (
        <Tag icon={<CheckCircleOutlined />} color="green">
          Concluído
        </Tag>
      );
    } else if (status === 2) {
      return (
        <Tag icon={<ClockCircleOutlined />} color="processing">
          Em andamento
        </Tag>
      );
    } else if (status === 0) {
      return (
        <Tag icon={<CloseCircleOutlined />} color="default">
          Não Aprovado
        </Tag>
      );
    } else {
      return <Tag color="orange">Não iniciado</Tag>;
    }
  };

  // ON SUBMIT
  const onSubmit = (values) => {
    concluirCurso({
      id: dados?.id,
      id_treinamentos_lancamento: dados?.id_treinamentos_lancamento,
      codigo: values?.codigo,
    });
  };

  // RENDER FOOTER
  const renderFooter = (data) => {
    if (data?.status === null) {
      return (
        <Button
          style={{ fontWeight: 600, fontSize: 18, height: "auto" }}
          size="large"
          type="primary"
          icon={<RightCircleOutlined />}
          onClick={() =>
            modal.confirm({
              title: "Deseja inscrever-se neste curso?",
              okText: "Sim",
              cancelText: "Cancelar",
              onOk() {
                iniciarCurso(data?.id);
              },
            })
          }>
          Inscrever-se
        </Button>
      );
    } else if (dayjs(data?.data_inicio) > dayjs()) {
      return (
        <Alert
          message={`Aguarde o início do período de realização (${dayjs(data?.data_inicio).format(
            "DD/MM/YYYY"
          )}) para continuar o curso/treinamento.`}
          type="info"
          showIcon
        />
      );
    } else if (data?.tipo === 1) {
      return (
        <Space direction="vertical" style={{ width: "100%" }}>
          {data?.modulos?.map((m) => {
            return (
              <ItemList
                key={m?.id}
                leftComponent={
                  <>
                    {m?.status === 1 && (
                      <div className="item-collapse-icon">
                        <CheckCircleOutlined style={{ fontSize: 22, color: "#60b565" }} />
                      </div>
                    )}

                    {m?.status === 2 && (
                      <div className="item-collapse-icon" style={{ backgroundColor: "#2194f245" }}>
                        <FormOutlined style={{ fontSize: 22, color: "#2194f2" }} />
                      </div>
                    )}

                    {m?.status === -1 && (
                      <div className="item-collapse-icon" style={{ backgroundColor: "#fff7e6" }}>
                        <ClockCircleOutlined style={{ fontSize: 22, color: "#edae73" }} />
                      </div>
                    )}
                  </>
                }
                onClick={() =>
                  (m?.status === 2 || m?.status === 1) &&
                  navigate(`/treinamentos/lancamento/grupos/cursos/${id_grupo}/detalhes/${id_curso}/modulo/${m?.id}`)
                }
                hoverable={m?.status === 2 || m?.status === 1 ? true : false}
                rightComponent={m?.status === 2 || m?.status === 1 ? <RightOutlined /> : <ClockCircleOutlined />}>
                <Space wrap size={5} direction="vertical">
                  <Text strong style={{ fontSize: 18 }}>
                    {m.descricao}
                  </Text>
                  <Space wrap>
                    <Text>Média: {maskMoney(m?.media ?? 0)}</Text>
                  </Space>
                </Space>
              </ItemList>
            );
          })}
        </Space>
      );
    } else if (data?.status === 2 && data?.tipo === 2) {
      return (
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Space.Compact style={{ width: "100%" }} size="large">
            <Form.Item name="codigo" rules={[{ required: true, message: "Informe o código!" }]}>
              <Input placeholder="Código de conclusão" />
            </Form.Item>
            <Button type="primary" onClick={() => form.submit()}>
              Enviar
            </Button>
          </Space.Compact>
        </Form>
      );
    }
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Treinamentos & Desenvolvimento"
              onClickBack={() => navigate(`/treinamentos/lancamento/grupos/cursos/${id_grupo}`)}
            />
            <HeaderTitle
              title={["Treinamentos & Desenvolvimento", "Grupos", "Treinamentos"]}
              subtitle={<Text italic>{grupo?.descricao ?? ""}</Text>}
              icon={<ReadOutlined />}
              loading={loading}
            />
            <Divider />
            <Space direction="vertical" style={{ width: "100%" }}>
              <Card bordered={false} bodyStyle={{ padding: "3%" }}>
                <Space direction="vertical">
                  <Text style={{ fontSize: 32, color: "#60b565" }} strong>
                    <ReadOutlined /> {dados?.descricao}
                  </Text>
                  <Text className="line-break" style={{ fontSize: 18 }}>
                    {dados?.observacoes}
                  </Text>
                </Space>

                <Divider />
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                  <RenderItem titulo="Tipo" descricao={array_tipo[dados?.tipo - 1]} />
                  <RenderItem titulo="Classificação" descricao={dados?.classificacao} />
                  <RenderItem
                    titulo="Carga Horária"
                    descricao={converterDecimalParaHorasMinutos(dados?.carga_horaria)}
                  />
                  <RenderItem titulo="Média Aprovação" descricao={maskMoney(dados?.media_aprovacao ?? 0)} />
                  <RenderItem titulo="Data Início" descricao={dayjs(dados?.data_inicio).format("DD/MM/YYYY")} />
                  <RenderItem titulo="Data Fim" descricao={dayjs(dados?.data_fim).format("DD/MM/YYYY")} />
                  <RenderItem
                    titulo="Obrigatório"
                    descricao={dados?.obrigatorio === 1 ? <Tag color="orange">Sim</Tag> : <Tag>Não</Tag>}
                  />
                  <RenderItem titulo="Média Obtida" descricao={maskMoney(dados?.media_obtida ?? 0)} />

                  <RenderItem titulo="Status" descricao={renderStatus(dados?.status)} />
                  <RenderItem
                    titulo="Data Conclusão"
                    descricao={dados?.data_conclusao ? dayjs(dados?.data_conclusao).format("DD/MM/YYYY") : "-"}
                  />
                </Row>
              </Card>

              {(dados?.status !== 1 || dados?.tipo !== 2) && (
                <Card bordered={false} bodyStyle={{ padding: "3%" }}>
                  <Col className="gutter-row" span={24}>
                    {renderFooter(dados)}
                  </Col>
                </Card>
              )}
            </Space>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
